module.exports = __webpack_public_path__ + "static/media/padding-area.67347599.svg";